// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2XUZz","productName":"Table_productName__2czXC"};